/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Descriptionhtml4Inputs */

const en__field_descriptionhtml4 = /** @type {(inputs: _Field_Descriptionhtml4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description (HTML)`)
};

const de__field_descriptionhtml4 = /** @type {(inputs: _Field_Descriptionhtml4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung (HTML)`)
};

/**
* | output |
* | --- |
* | "Description (HTML)" |
*
* @param {_Field_Descriptionhtml4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_descriptionhtml4 = /** @type {((inputs?: _Field_Descriptionhtml4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Descriptionhtml4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_descriptionhtml4(inputs)
	return de__field_descriptionhtml4(inputs)
});
export { _field_descriptionhtml4 as "_field_descriptionHTML" }